import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { GlassCard } from '../components/ui/GlassCard';
import { Lock, AlertCircle } from 'lucide-react';
export function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const {
        data,
        error
      } = await supabase.auth.signInWithPassword({
        email: email.trim(),
        password: password
      });
      if (error) {
        // Provide helpful error messages
        if (error.message.includes('Invalid login credentials')) {
          throw new Error('Invalid email or password. Please check your credentials.');
        } else if (error.message.includes('Email not confirmed')) {
          throw new Error('Please confirm your email address. Check your inbox for a confirmation link.');
        } else {
          throw new Error(error.message);
        }
      }
      if (data.session) {
        console.log('✅ Login successful');
        navigate('/admin/dashboard');
      } else {
        throw new Error('Login failed - no session created');
      }
    } catch (err: any) {
      console.error('Login error:', err);
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen bg-black flex items-center justify-center p-4" data-id="element-794">
      {/* Background */}
      <div className="fixed inset-0 z-0 pointer-events-none" data-id="element-795">
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-cyan-500/10 to-blue-500/10 rounded-full blur-[120px]" data-id="element-796" />
        <div className="absolute bottom-0 right-0 w-[700px] h-[700px] bg-gradient-to-tl from-purple-500/10 to-pink-500/10 rounded-full blur-[120px]" data-id="element-797" />
      </div>

      <GlassCard className="w-full max-w-md p-8 border-white/10 relative z-10" data-id="element-798">
        <div className="text-center mb-8" data-id="element-799">
          <div className="w-12 h-12 bg-white/5 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-800">
            <Lock size={24} className="text-white" data-id="element-801" />
          </div>
          <h1 className="text-2xl font-bold text-white font-special" data-id="element-802">
            Admin Login
          </h1>
          <p className="text-gray-400 text-sm mt-2" data-id="element-803">
            Sign in to manage tool submissions
          </p>
        </div>

        {error && <div className="mb-4 p-4 rounded-lg bg-red-500/10 border border-red-500/20" data-id="element-804">
            <div className="flex items-start gap-3" data-id="element-805">
              <AlertCircle size={20} className="text-red-400 shrink-0 mt-0.5" data-id="element-806" />
              <p className="text-red-400 text-sm" data-id="element-807">{error}</p>
            </div>
          </div>}

        <form onSubmit={handleLogin} className="space-y-4" data-id="element-808">
          <div data-id="element-809">
            <label className="block text-sm font-medium text-gray-400 mb-1" data-id="element-810">
              Email
            </label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@example.com" className="w-full px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-white placeholder-gray-600 focus:border-cyan-500/50 focus:outline-none" required autoComplete="email" data-id="element-811" />
          </div>
          <div data-id="element-812">
            <label className="block text-sm font-medium text-gray-400 mb-1" data-id="element-813">
              Password
            </label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="w-full px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-white placeholder-gray-600 focus:border-cyan-500/50 focus:outline-none" required autoComplete="current-password" data-id="element-814" />
          </div>
          <button type="submit" disabled={loading} className="w-full py-3 rounded-lg bg-cyan-500 hover:bg-cyan-600 text-white font-bold transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-815">
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="mt-6 text-center text-xs text-gray-500" data-id="element-816">
          <p data-id="element-817">Secured with Supabase Authentication</p>
        </div>
      </GlassCard>
    </div>;
}